<template>
  <div class="bg-white border-radius-lg">
    <highcharts
      :options="computedOptions"
      class="border-radius-lg p-1"
    ></highcharts>
  </div>
</template>

<script>
export default {
  name: "ChartProductosColumn",
  props: {
    seriesData: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: "Detalle de Ventas por Producto"
    },
    subtitle: {
      type: String,
      default: "Montos generados por ventas de productos"
    }
  },
  computed: {
    computedOptions() {
      return {
        chart: { type: 'column' },
        title: { text: this.title },
        subtitle: { text: this.subtitle },
        accessibility: {
            announceNewData: {
                enabled: true
            }
        },
        xAxis: {
            type: 'category'
        },
        yAxis: {
            title: {
                text: 'Rango de Montos (Bs.)'
            }

        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y:.2f}'
                }
            }
        },

        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: ' +
                '<b>{point.y:.2f}</b> Bs<br/>'
        },

        series: [
            {
                name: 'Productos',
                colorByPoint: true,
                colors: [
                    '#4F2DA3',
                    '#7B41B6',
                    '#B850CD',
                    '#F6D7DE',
                    '#E895BE',
                    '#CCC1E4',
                    '#9444BC',
                    '#EA69D4'
                ],
                data: this.seriesData
            }
        ]
      };
    }
  }
};
</script>